import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import DeliveryForm from "../DeliveryForm/DeliveryForm";
import editIcon from "../../common/assets/svg/editAddress.svg";
import deleteIcon from "../../common/assets/svg/addressTrash.svg";
import {
  deleteDeliveryAddressRequest,
  setSelectedDeliveryAddress,
  viewDeliveryAddressRequest,
} from "../../common/features/restaurant/restaurantAction";
import { ReactComponent as Preferences } from "../../common/assets/svg/note-pen.svg";
import { setDeliveryInstructions, setOrderInstructions } from "../../common/features/cart/cartActions";
import { getCookie } from "../../helper/cookieHelper";
import { USER_ID } from "../../common/constants";

const DeliveryDetails = ({
  onClose,
  addresses,
  selectedAddressId,
  onAddressSelect,
  onEditAddress,
  handleDeleteAddress,
  onAddNewAddress,
  handleDeliveryFormSubmit,
  handleAddressFieldOnChange,
  // onDeleteAddress,
  deliveryAddress,
  selectedAddress,
  setSelectedAddress,
  center,
  isDesktop
}: any) => {
  const allDeliveryAddresses = useSelector((state: any) => state.restaurant?.deliveryAddress?.addresses)
 const isMobile = useSelector((state:any)=>state?.navigation?.isMobile)
  const [showForm, setShowForm] = useState(allDeliveryAddresses?.length > 0 ? false : true);
  const [editForm, setEditForm] = useState<boolean>();
  const [selectedAddressIndex, setSelectedAddressIndex] = useState<number>();
  const [editAddress, setEditAddress] = useState({})
  const dispatch = useDispatch();
  const orderInstruction = useSelector((state: any) => state.cart.orderInstruction);
  const deliveryInstruction = useSelector((state: any) => state.cart.deliveryInstruction);
  const cart = useSelector((state: any) => state.cart.cart.items)
  
  const handledeliverySelection = (index: number, delivery: any) => {
    setSelectedAddressIndex(delivery?.id);
    onAddressSelect(delivery);
    dispatch(setSelectedDeliveryAddress(delivery));
  };

  useEffect(() => {
    if ((allDeliveryAddresses?.length < 1)) {
      setShowForm(true)
    } else {
      setShowForm(false)
    }

  }, [allDeliveryAddresses])

  const selectedDeliveryAddress = useSelector(
    (state: any) => state.restaurant.selectedDeliveryAddress
  );

  const deliveryAddressLoading = useSelector(
    (state: any) => state.restaurant?.deliveryAddressLoading
  );

  const addDeliveryAddressLoading = useSelector(
    (state: any) => state.restaurant?.addDeliveryAddressLoading
  );

  const onDeleteAddress = (id: any) => {
    dispatch(deleteDeliveryAddressRequest(id))
  };
  useEffect(() => {
    // Only fetch delivery address if customerID exists
    const customerID = getCookie(USER_ID);
    if (customerID) {
      dispatch(viewDeliveryAddressRequest());
    }
  }, []);

  return (
    <div className="delivery-details-checkout">
      {!showForm && (
        <>
          <p className="header-info">
            Choose a delivery address from the list below or add a new one.
          </p>

          {(!deliveryAddressLoading && !addDeliveryAddressLoading) ? (
            allDeliveryAddresses?.length > 0 && (
              <>
                <div className="address-card-checkout">
                  {allDeliveryAddresses?.map((address: any, index: any) => (
                    <div className="address-card-checkout-wrapper">
                      <div
                        className="address-info-checkout"
                        onClick={e => {
                          e.stopPropagation();
                          e.preventDefault();
                          handledeliverySelection(index, address);
                        }}
                      >
                        <div className="adderss-header-checkout">
                          <input
                            type="radio"
                            className="radio-btn-checkout"
                            checked={address?.id === selectedDeliveryAddress?.id}
                          />
                          <h3 className="address-type-checkout">{address?.tag}</h3>
                        </div>
                        <div className="adderss-text-checkout">
                          {address?.addressLine1 ? <p> {address?.addressLine1}</p> : null}
                          {address?.addressLine2 ? <p> {address?.addressLine2}</p> : null}
                          {/* {address?.apartment?<p>{address?.apartment},</p>:null} */}
                          {address?.city ? <p>{address?.city},</p> : null}
                          {address?.state ? <p>{address?.state},</p> : null}
                          {address?.postalCd ? <p>{address?.postalCd}.</p> : null}
                        </div>
                      </div>
                      <div className="address-actions-checkout">
                        <img
                          src={editIcon}
                          alt="edit"
                          className="edit-icon"
                          onClick={e => {
                            // e.stopPropagation();
                            setEditForm(true);
                            setSelectedAddressIndex(address?.id);
                            setEditAddress(address);
                            setShowForm(true);
                            // handledeliverySelection(index, address);
                          }}
                        />
                        <img
                          src={deleteIcon}
                          alt="delete"
                          className="delete-icon"
                          onClick={() => {
                            // handledeliverySelection(index, address);
                            onDeleteAddress(address?.id);
                          }}
                        />
                      </div>{' '}
                    </div>
                  ))}
                </div>
                <div className="delivery-instructionss-container">
                <div className="note-input-container-Delivery ">
                  <Preferences className="input-icon" />
                  <input
                    type="text"
                    className="order-instructions-Delivery"
                    maxLength={30}
                    placeholder="Type delivery instructions if any"
                    value={deliveryInstruction}
                    style={{ color: deliveryInstruction?.length === 30 ? "red" : "black" }}
                    onChange={(e) => dispatch(setDeliveryInstructions(e.target.value))}
                    />
                    </div>
                </div>
                </>
                  )
                  ) : (
                  <div className="loader-container-desktop-deliveryForm">
                    <div className="Loaders-deliveryForm"></div>
                  </div>
          )}

                  {!deliveryAddressLoading && <p
                    className={
                      isDesktop ? 'add-new-address-btn-checkout-desktop' : 'add-new-address-btn-checkout'
                    }
                    onClick={() => {
                      setShowForm(true);
                      setEditForm(false);
                    }}
                  >
                    Add New Address
                  </p>}
                </>
      )}
                {showForm && (
                  <DeliveryForm
                    center={center}
                    onClose={() =>
                      allDeliveryAddresses?.length > 0 || isMobile ? setShowForm(false) : onClose('')
                    }
                    setShowForm={editForm ? setEditForm : setShowForm}
                    edit={editForm}
                    handleDeliveryFormSubmit={handleDeliveryFormSubmit}
                    handleAddressFieldOnChange={handleAddressFieldOnChange}
                    editAddress={editForm ? editAddress : selectedAddress}
                    isDesktop={isDesktop}
                  />
                )}
              </div>
          );
};

          export default DeliveryDetails;
